import React, { useState, useEffect } from "react";
import { Box, Card, Grid, Typography, Button, Paper, Tooltip, TableContainer, Modal, Divider, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, alpha } from "@mui/material";

import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { tokens } from "../../../theme/theme";
import GlobalConfig from "../../../config/date/GlobalConfig";

import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import CustomPagination from "../../../components/table/CustomPagination";
import Close from '@mui/icons-material/Close';
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportToExcel } from "../../../components/ExportToExcel";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const FGChildReelReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [open, setOpen] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };


    const getReportData = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };
        setLoading(true);
        callApi(API_ENDPOINTS.REPORT_GetreportProductionGetFGChildRollDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                setLoadingData(data);
                setLoading(false);
            })
            .catch(error => {
                alert(error);
            });

    };

    useEffect(() => {
        // Fetch data when FromDate or ToDate changes
        getReportData();
    }, [FromDate, ToDate]);


    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        item_code: '',
        gsm: '',
        width: '',
        length: '',
    });
    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const excelColumns = [
        { header: "REEL WEIGHTMENT PROD. DATE", key: "date" },        // 0
        { header: "SHIFT", key: "shift_code" },                       // 1
        { header: "ROLL NO", key: "pr_number" },                      // 2
        { header: "REEL NO", key: "child_reel_number" },              // 3
        { header: "QUALITY", key: "item_code" },                      // 4
        { header: "GRADE", key: "grade" },                            // 5
        { header: "GSM", key: "gsm" },                                // 6 ✅ number
        { header: "SIZE1", key: "width" },                            // 7 ✅ number
        { header: "WEIGHT", key: "achieved_qty" },                    // 8 ✅ number
        { header: "P.O NO.", key: "po_no" },                          // 9
        { header: "REMARKS", key: "production_remarks" },             // 10
    ];

    const dateColumnIndexes = [0]; // REEL WEIGHTMENT PROD. DATE

    const handleExportToExcel = () => {

           exportToExcel({
            data: filteredData,
            fileName: 'Reel Production Detail Report.xlsx',
            sheetName: 'Reel Production Detail',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,

        });

        
        // Prepare the data with headers

        // const formattedData = filteredData.map(row => ({

        //     "REEL WEIGHTMENT PROD. DATE": row.date ? new Date(row.date) : "", // ensures proper Excel format
        //     "SHIFT": row.shift_code,
        //     "ROLL NO": row.pr_number,
        //     "REEL NO": row.child_reel_number,
        //     "QUALITY": row.item_code,
        //     "GRADE": row.grade,
        //     "GSM": row.gsm,
        //     "SIZE1": row.width,
        //     "WEIGHT": row.achieved_qty,
        //     "P.O NO.": row.po_no,
        //     "REMARKS": row.production_remarks,

        // }));

     
    };

    const HandleClose = () => {
        handleExportToExcel();
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);

    const uniqueValues = {

        shift_code: [...new Set(loadingData.map(row => row.shift_code))],
        pr_number: [...new Set(loadingData.map(row => row.pr_number))],
        child_reel_number: [...new Set(loadingData.map(row => row.child_reel_number))],
        item_code: [...new Set(loadingData.map(row => row.item_code))],
        grade: [...new Set(loadingData.map(row => row.grade))],
        gsm: [...new Set(loadingData.map(row => row.gsm))],
        po_no: [...new Set(loadingData.map(row => row.po_no))],
    };



    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const columns = ['date', 'shift_code', 'pr_number', 'child_reel_number', 'item_code', 'grade', 'gsm', 'width', 'achieved_qty', 'po_no', 'production_remarks'];

    const autoCompleteColumns = ['shift_code', 'pr_number', 'child_reel_number', 'item_code', 'grade', 'gsm', 'po_no'];

    const totals = {
        achieved_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.achieved_qty) || 0), 0),

    };

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };


    return (
        <>


            <Divider />
            <Box display="flex" flexDirection={'column'}>

                <Box m='0px' display="flex" alignItems={'center'}  >

                    <Divider orientation="vertical" flexItem sx={{ mx: 0 }} />

                    <Box marginRight="auto" marginLeft={1}>
                        <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >Reel Production Detail Report</Typography>
                    </Box>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />


                    <Grid item lg={2} xs={4} xl={2}>
                    
                     <CustomDatePicker
                                value={FromDate}
                                onChange={(date) => handleDateChange2(date)}
                                autoFocus={true}
                            />
                    </Grid>

                    <Grid item mt="2px" ml="10px" mr="10px">
                        <Typography fontWeight="bold">-</Typography>
                    </Grid>

                    <Grid item lg={2} xs={4} xl={2}>
                      <CustomDatePicker
                                value={ToDate}
                                onChange={(date) => handleDateChange1(date)}
                            />
                    </Grid>


                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    <Grid item mt="2px" ml="0px" mr="5px">

                        <Tooltip title="Download Report" onClick={HandleClose}>
                            <IconButton >
                                <FileDownloadIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>

                    <Divider orientation="vertical" flexItem />
                    <Grid item mt="2px" ml="5px" mr="5px" justifyContent="center">
                        <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                    </Grid>
                    <Divider orientation="vertical" flexItem />
                </Box>
            </Box>

            <Divider />
            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                <CustomTableContainer colors={colors}>


                    <TableContainer >
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (
                            <Table stickyHeader size="small" sx={{ tableLayout: 'fixed' }}>
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                        <TableCell sx={{ width: '200px' }}>REEL WEIGHTMENT PROD. DATE</TableCell>
                                        <TableCell>SHIFT</TableCell>
                                        <TableCell sx={{ width: '100px' }}>ROLL NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}>QUALITY </TableCell>
                                        <TableCell sx={{ width: '60px' }}>GRADE</TableCell>
                                        <TableCell sx={{ width: '60px' }}>GSM </TableCell>
                                        <TableCell sx={{ width: '60px' }}>SIZE1</TableCell>
                                        <TableCell sx={{ width: '80px' }}>WEIGHT </TableCell>
                                        <TableCell sx={{ width: '120px' }}>P.O NO.</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REMARKS</TableCell>


                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />


                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{

                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>


                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.shift_code}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.child_reel_number}</TableCell>
                                            <TableCell>{row.item_code}</TableCell>
                                            <TableCell>{row.grade}</TableCell>
                                            <TableCell>{row.gsm}</TableCell>
                                            <TableCell>{row.width}</TableCell>
                                            <TableCell>{row.achieved_qty}</TableCell>
                                            <TableCell>{row.po_no}</TableCell>
                                            <TableCell>{row.production_remarks}</TableCell>

                                        </TableRow>
                                    ))}

                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={8} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.achieved_qty.toFixed(2)}</TableCell>
                                        <TableCell /> {/* SIZE1 */}
                                        <TableCell /> {/* SIZE2 */}



                                    </TableRow>
                                </TableBody>
                            </Table>)}

                    </TableContainer>


                </CustomTableContainer>
            </ResponsiveBox>
            <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />



        </>
    )
};
export default FGChildReelReport;